import { render } from "./TokenAuth.vue?vue&type=template&id=464cc344&scoped=true"
import script from "./TokenAuth.vue?vue&type=script&lang=js"
export * from "./TokenAuth.vue?vue&type=script&lang=js"

import "./TokenAuth.vue?vue&type=style&index=0&id=464cc344&lang=scss&scoped=true"
import "./TokenAuth.vue?vue&type=style&index=1&id=464cc344&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464cc344"]])

export default __exports__